import React from 'react'
import { useParams } from 'react-router-dom'
import SetUserType from '../../../components/SetUserType'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const { id } = useParams()
  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Change user type</h1>}></ContextMenu>
      <SetUserType userId={id} />
    </div>
  )
}
